import {Tooltip} from '@crunchyroll/cx-web-components';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import styles from "./CommentingSection.module.scss";

const CommentActionsTooltip = ({isVisible, children}) => {
  if (!isVisible) {
    return children;
  }

  return (
    <Tooltip content={<FormattedMessage id="comment.spoiler_tooltip_action" />}>
      <div className={styles.commentActionsTooltip}>{children}</div>
    </Tooltip>
  );
};

CommentActionsTooltip.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
};

CommentActionsTooltip.defaultProps = {
  isVisible: false,
};

export default CommentActionsTooltip;